<template>
	<div>
		<a-button-group v-if="mode === 'button'" :class="$style.btnGroup">
			<slot name="left" />

			<slot name="edit">
				<a-tooltip
					v-if="
						$gestios.items(app).auth({
							scopes: [`set.mine`, `set`],
							strict: false,
							item,
						}) && edit
					"
					placement="top"
				>
					<template slot="title">
						<span>
							<fa-icon
								:icon="['far', 'edit']"
								class="mr-2"
							/>Editar
						</span>
					</template>
					<a-button :size="size" @click="$emit('edit', item)">
						<fa-icon :icon="['far', 'edit']" />
					</a-button>
				</a-tooltip>
			</slot>

			<slot name="middle" />

			<slot name="delete">
				<a-popconfirm
					v-if="
						$gestios.items(app).auth({
							scopes: [`del.mine`, `del`],
							strict: false,
							item,
						}) && this.delete
					"
					title="¿Estas seguro que deseas borrar este elemento?"
					@confirm="() => deleteItem([item])"
				>
					<a-tooltip placement="top">
						<template slot="title">
							<span>
								<fa-icon
									:icon="['far', 'trash-alt']"
									class="mr-2"
								/>
								Eliminar
							</span>
						</template>
						<a-button type="danger" :size="size">
							<fa-icon :icon="['far', 'trash-alt']" />
						</a-button>
					</a-tooltip>
				</a-popconfirm>
			</slot>

			<slot name="right" />
		</a-button-group>

		<a-button-group v-if="mode === 'dropdown'" :class="$style.btnGroup">
			<slot v-if="text" name="text">
				<a-button :size="size"> Acciones </a-button>
			</slot>

			<a-dropdown :trigger="!disabled ? ['click'] : []">
				<slot name="action">
					<a-button :size="size" :disabled="disabled || loading">
						<fa-icon
							:icon="['fas', loading ? 'sync-alt' : 'ellipsis-v']"
							:spin="loading"
						/>
					</a-button>
				</slot>

				<a-menu slot="overlay">
					<slot name="top" />

					<a-menu-divider v-if="editOrDelete" />

					<slot name="middle" />

					<slot name="edit">
						<a-menu-item
							v-if="
								$gestios.items(app).auth({
									scopes: [`set.mine`, `set`],
									strict: false,
									item,
								}) && edit
							"
							key="_edit"
							@click="$emit('edit', item)"
						>
							<fa-icon
								:icon="['fas', 'edit']"
								class="mr-2"
							/>Editar
						</a-menu-item>
					</slot>

					<slot name="delete">
						<a-menu-item
							v-if="
								$gestios.items(app).auth({
									scopes: [`del.mine`, `del`],
									strict: false,
									item,
								}) && remove
							"
							key="_delete"
							class="text-danger"
						>
							<a-popconfirm
								title="¿Estas seguro que deseas borrar este elemento?"
								@confirm="() => deleteItem(item)"
							>
								<fa-icon
									:icon="['fas', 'trash-alt']"
									class="mr-2"
								/>Eliminar
							</a-popconfirm>
						</a-menu-item>
					</slot>

					<slot name="bottom" />
				</a-menu>
			</a-dropdown>
		</a-button-group>
	</div>
</template>

<script>
export default {
	name: "GItemActions",
	props: {
		mode: {
			type: String,
			default: "button",
		},
		app: {
			type: String,
			required: true,
		},
		item: {
			type: Object,
			required: true,
		},
		size: {
			type: String,
			default: "default",
		},
		delete: {
			type: Boolean,
			default: true,
		},
		edit: {
			type: Boolean,
			default: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		text: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		editOrDelete() {
			const delAuth = this.$gestios.items(this.app).auth({
				scopes: ["del.mine", "del"],
				strict: false,
				item: this.item,
			});

			const setAuth = this.$gestios.items(this.app).auth({
				scopes: ["set.mine", "set"],
				strict: false,
				item: this.item,
			});

			if (this.delete && delAuth) return true;
			if (this.edit && setAuth) return true;

			return false;
		},
		remove() {
			return this.delete;
		},
	},
	methods: {
		async deleteItem(item) {
			const result = await this.$gestios
				.items(this.app)
				.delete({ id: item._EntityId });

			if (!result.ok) {
				this.$toast.error(
					"No se pudo borrar el registro. Asegurate de tener permisos."
				);
			} else {
				this.$toast.success("Elemento borrado correctamente");
			}
		},
	},
};
</script>

<style lang="scss" module>
.btnGroup {
	white-space: nowrap;
}
</style>
